// 等待 jQuery 加载完成后再执行（兼容 jq 加载慢的情况）
function runWhenjQueryReady(callback) {
  if (typeof window.$ !== "undefined" || typeof window.jQuery !== "undefined") {
    callback(window.$ || window.jQuery);
  } else {
    setTimeout(function () {
      runWhenjQueryReady(callback);
    }, 50);
  }
}

runWhenjQueryReady(function ($) {
  // 加入购物车点击事件（支持单品 data-variantid 或套装 data-variant-ids 逗号分隔）
  $(document).on("click", ".ro-add-to-cart", function(t) {
    t.preventDefault();
    let addToCart = t.currentTarget;
    let items = [];
    let quantity = 1;
    if (addToCart.dataset.quantitySelectorId) {
      let selectorId = addToCart.dataset.quantitySelectorId;
      if (window.RoQuantitySelectors && window.RoQuantitySelectors[selectorId]) {
        let selectorQuantity = window.RoQuantitySelectors[selectorId].getValue();
        if (typeof selectorQuantity === "number" && !isNaN(selectorQuantity) && selectorQuantity >= 1) {
          quantity = selectorQuantity;
        }
      }
    }
    if (addToCart.dataset.variantIds) {
      // 买X送Y 等：同时加购多个变体
      let ids = addToCart.dataset.variantIds.split(",").map(function(id) { return id.trim(); }).filter(Boolean);
      items = ids.map(function(id) { return { id: id, quantity: quantity }; });
    } else {
      let id = addToCart.dataset.variantid;
      items = [{ id: id, quantity: quantity }];
    }
    let data = { items: items };

    // 防止重复点击
    if (addToCart.hasAttribute("disabled")) {
      return;
    }

    // 禁用按钮
    addToCart.setAttribute("disabled", "disabled");
    // 当按钮没有"svg"类名时，才改变按钮内容（Pad、Mob端：显示SVG图标，加个类名做判断）
    if (addToCart && !addToCart.classList.contains("svg")) {
      addToCart.innerText = addToCart.dataset.loadingText || addToCart.dataset.normalText;
    }

    // 重置按钮
    const resetAddToCart = () => {
      addToCart.removeAttribute("disabled");
      // 当按钮没有"svg"类名时，才改变按钮内容（Pad、Mob端：显示SVG图标，加个类名做判断）
      if (addToCart && !addToCart.classList.contains("svg")) {
        addToCart.innerText = addToCart.dataset.normalText || "";
      }
    };

    axios({
      url: "/cart/add.js",
      method: "POST",
      data: data
    }).then((res) => {
      // 触发自定义事件，告知加购成功
      addToCart.dispatchEvent(new CustomEvent("cart:item-added", { bubbles: true }));
      // 更新购物车商品数量显示
      updateCartItemsCount(addToCart);
      // 重置按钮
      resetAddToCart();
    }, (err) => {
      console.log(err);
      // 重置按钮
      resetAddToCart();
      // Toast提示
      const { description } = err.response.data;
      showToast(description);
    });
  });
});

/**
 * 更新购物车商品数量显示
 * 
 * 该函数用于更新页面上购物车图标旁边的商品数量显示。
 * 如果商品数量大于0，则显示数量；如果数量小于99，显示实际数量；
 * 如果数量大于等于99，则显示"99+"；如果数量为0，则隐藏数量显示。
 */
function updateCartItemsCount(target = null) {
  axios({
    url: "/cart.js",
    method: "GET"
  }).then((res) => {
    let count = res.data.item_count; // 购物车商品数量
    let countDom = document.querySelector(".cart-link .cart-items-count");

    if (countDom && count > 0) {
      countDom.classList.add("show");
      countDom.innerText = count < 100 ? count : "99+";

      // Toast提示
      let toastText = target?.dataset?.toastText || "Toast";
      showToast(toastText);
    }
  }, (err) => {
    console.log(err);
  });
}

// Toast提示
function showToast(msg = '') {
  // Toast定时器
  let toastTimer = null;

  // Toast Dom
  let toastDom = document.querySelector(".ro-toast");
  let toastTextDom = document.querySelector(".ro-toast .ro-toast-text");

  if (!toastDom || !toastTextDom) return;

  // 如果已经有Toast提示，则清除定时器
  if (toastTimer) {
    clearTimeout(toastTimer);
    toastTimer = null;
  }

  toastDom.classList.add("show");
  toastDom.style.position = "fixed";
  toastDom.style.bottom = "50%";
  toastTextDom.innerText = msg;

  toastTimer = setTimeout(() => {
    toastDom.classList.remove("show");
    toastTimer = null;
  }, 2000);
}